// UAT
export const envConfig = {
    auth: {
        clientId: "ed0ad555-6b7c-435a-8b85-1de51f3b99ce",             //UAT AZURE
        authority: "https://login.microsoftonline.com/vylor.com",
        redirectUri: "https://uat.vylorseedresearch.com/",            // UAT AZURE
        //redirectUri: "http://localhost:3000",                  // local redirect URI
    },
};


// DEV-Environment
// export const envConfig = {
//     auth: {
//         clientId: "463fc679-2d86-4913-b141-408b34ced827",            //DEV AZURE
//         authority: "https://login.microsoftonline.com/vylor.com",
//         // redirectUri: "http://localhost:3000", // local redirect URI
//         redirectUri: "https://dev.vylorseedresearch.com/",            // DEV AZURE
//     },
// };

// PRODUCTION
// export const envConfig = {
//     auth: {
//         clientId: "9d6ac033-5951-4f32-b244-805b0535804b",
//         authority: "https://login.microsoftonline.com/vylor.com",
//         redirectUri: "https://vylorseedresearch.com/",
//         //redirectUri: "http://localhost:3000",
//     },
// };
